function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M58.963,44.119c-0.116-0.367-0.434-0.634-0.814-0.688l-7.777-1.089l-3.472-6.78c-0.342-0.668-1.438-0.668-1.779,0 l-3.472,6.78l-7.777,1.089c-0.381,0.054-0.698,0.32-0.814,0.688s-0.012,0.768,0.269,1.031l5.605,5.267l-1.321,7.427 c-0.066,0.373,0.084,0.752,0.388,0.978c0.305,0.227,0.711,0.262,1.049,0.089l6.964-3.528l6.964,3.528 c0.143,0.073,0.298,0.108,0.452,0.108c0.211,0,0.421-0.066,0.597-0.197c0.304-0.226,0.454-0.604,0.388-0.978l-1.321-7.427 l5.605-5.267C58.974,44.887,59.079,44.486,58.963,44.119z M51.325,49.33c-0.246,0.231-0.359,0.571-0.3,0.903l1.064,5.987 l-5.628-2.852c-0.143-0.072-0.297-0.108-0.452-0.108s-0.31,0.036-0.452,0.108l-5.628,2.852l1.064-5.987 c0.06-0.332-0.054-0.672-0.3-0.903l-4.479-4.207l6.225-0.872c0.322-0.045,0.603-0.244,0.751-0.534l2.818-5.504l2.818,5.504 c0.148,0.29,0.429,0.489,0.751,0.534l6.225,0.872L51.325,49.33z"
}), React.createElement("path", {
  d: "M36.01,32h9V21h-9h-2h-7h-2h-7h-2h-9v9v2v7v2v9h9h2h9v-9h9V32z M36.01,23h7v7h-7V23z M27.01,23h7v7h-7V23z M18.01,23h7v7 h-7V23z M25.01,39h-7v-7h7V39z M9.01,23h7v7h-7V23z M9.01,32h7v7h-7V32z M16.01,48h-7v-7h7V48z M25.01,48h-7v-7h7V48z M34.01,39h-7 v-7h7V39z"
}), React.createElement("path", {
  d: "M26.01,55h-24V16h48v17c0,0.553,0.447,1,1,1s1-0.447,1-1V15V5c0-0.553-0.447-1-1-1h-5V1c0-0.553-0.447-1-1-1h-7 c-0.553,0-1,0.447-1,1v3h-22V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3h-5c-0.553,0-1,0.447-1,1v10v41c0,0.553,0.447,1,1,1 h25c0.553,0,1-0.447,1-1S26.562,55,26.01,55z M39.01,2h5v3v3h-5V5V2z M8.01,2h5v3v3h-5V5V2z M2.01,6h4v3c0,0.553,0.447,1,1,1h7 c0.553,0,1-0.447,1-1V6h22v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h4v8h-48V6z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "fill-current h-16",
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.019 59.019",
    style: {
      "enableBackground": "new 0 0 59.019 59.019"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/calendar.2bece0e8.svg";
export { SvgComponent as ReactComponent };